import './admin-reimpersonate'
import setupFirmFilterer from './firm-filterer'
import setupAmlFilterer from './aml-filterer'
import setupCompanyFilterer from './company-filterer'
import getAdapter from '@app/adapters/$get'
import select2Adapter from '@app/adapters/select2'
import { onNextPageTeardown } from '@app/adapters/page-teardown'

onDomLoad(function ($dom) {
  const unsubscribe = setupFirmFilterer($dom, {
    get: getAdapter,
    select2: select2Adapter,
  })

  const unsubscribeAml = setupAmlFilterer($dom, {
    get: getAdapter,
    select2: select2Adapter,
  })

  const unsubscribeCompany = setupCompanyFilterer($dom, {
    get: getAdapter,
    select2: select2Adapter,
  })

  onNextPageTeardown(() => {
    unsubscribe()
    unsubscribeAml()
    unsubscribeCompany()
  })
})
